import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import { Badge, Button, Col, Modal, Row } from "react-bootstrap";
import { apiResponse } from "../../utils/apiResponse";
import { useSelector } from "react-redux";
// import Budget from "../RevenueManagement/ListingComponent";
import Budget from "../RevenueManagement/ListingComponent/AnnualSummary/Budget";
import NetStly from "../RevenueManagement/ListingComponent/AnnualSummary/NetStly";
import OnTheBook from "../RevenueManagement/ListingComponent/AnnualSummary/OnTheBook";
import TotalLy from "../RevenueManagement/ListingComponent/AnnualSummary/TotalLy";
import OneDay from "../RevenueManagement/ListingComponent/PickUp/OneDay";
import OneDayForecastChange from "../RevenueManagement/ListingComponent/PickUp/OneDayForecastChange";

import ThreeDayForecastChange from "../RevenueManagement/ListingComponent/PickUp/ThreeDayForecastChange";
import ThreeDay from "../RevenueManagement/ListingComponent/PickUp/ThreeDay";

import SevenDay from "../RevenueManagement/ListingComponent/PickUp/SevenDay";
import SevenDayForecastChange from "../RevenueManagement/ListingComponent/PickUp/SevenDayForecastChange";
import Group from "../RevenueManagement/ListingComponent/Group/Group";
import GroupLastYear from "../RevenueManagement/ListingComponent/Group/GroupLastYear";
import Transient from "../RevenueManagement/ListingComponent/Group/Transient";
import TransientLastYearGroup from "../RevenueManagement/ListingComponent/Group/TransientLastYear";
import ORG from "../RevenueManagement/ListingComponent/DailySummary/ORG";
import PickupFrom from "../RevenueManagement/ListingComponent/DailySummary/PickupFrom";
import ReservationActivity from "../RevenueManagement/ListingComponent/ReservationActivity/ReservationActivity";
import HeatMap from "../RevenueManagement/ListingComponent/HeatMap/HeatMap";
import CancellationHeatMap from "../RevenueManagement/ListingComponent/HeatMap/CancellationHeatMap";
import WidgetBudgetGraph from "../RevenueManagement/ListingComponent/WidgetBudget/WidgetBudgetGraph";
import Spider from "../RevenueManagement/ListingComponent/Forecast/Spider";
import Rms from "../RevenueManagement/ListingComponent/Forecast/Rms";
import User from "../RevenueManagement/ListingComponent/Forecast/User";
import ChoiceRes from "../RevenueManagement/ListingComponent/ChoiceRes/ChoiceRes";
import MstReservation from "../RevenueManagement/ListingComponent/MstReservation/MstReservation";
import DailyDataTransaction from "../RevenueManagement/ListingComponent/DailyDataTransaction/DailyDataTransaction";
import EMAForecast from "../RevenueManagement/ListingComponent/Forecast/EMAForecast";
import AnnualSummaryChart from "../RevenueManagement/ListingComponent/AnnualSummary/AnnualSummaryChart";
import ForecastChart from "../RevenueManagement/ListingComponent/Forecast/ForecastChart";
import PickupChart from "../RevenueManagement/ListingComponent/PickUp/PickupChart";
import GroupChart from "../RevenueManagement/ListingComponent/Group/GroupChart";

import GroupWash from "../RevenueManagement/ListingComponent/GroupWash/GroupWash";


import BookinPaceChart from "../RevenueManagement/ListingComponent/BookingPace/BookinPaceChart";
import MarketSegmentChart from "../RevenueManagement/ListingComponent/MarketSegment/MarketSegmentChart";
import DayOfWeekSegmentMix from "../RevenueManagement/ListingComponent/MarketSegment/DayOfWeekSegmentMix";

import ChoiceOccupancy from "../RevenueManagement/ListingComponent/WidgetModule/ChoiceOccupancy";
import HotelKeyReservation from "../RevenueManagement/ListingComponent/WidgetModule/HotelKeyReservation";
import HotelKeyOccupancySnapshot from "../RevenueManagement/ListingComponent/WidgetModule/HotelKeyOccupancySnapshot";
import BestWesternGuestName from "../RevenueManagement/ListingComponent/WidgetModule/BestWesternGuestName";
import BestWesternReservationAgent from "../RevenueManagement/ListingComponent/WidgetModule/BestWesternReservationAgent";
import BestWesternReservationForecast from "../RevenueManagement/ListingComponent/WidgetModule/BestWesternReservationForecast";
import BestWesternRoomMaintaince from "../RevenueManagement/ListingComponent/WidgetModule/BestWesternRoomMaintaince";
import ChoiceCancelationSummaryReport from "../RevenueManagement/ListingComponent/WidgetModule/ChoiceCancelationSummaryReport";
import AdrVsRateChart from "../RevenueManagement/ListingComponent/Chart/AdrVsRateChart";
import WidgetPickup from "../RevenueManagement/ListingComponent/WidgetModule/WidgetPickup";
import BookingPaceTable from "../RevenueManagement/ListingComponent/BookingPace/BookingPaceTable";
import AnnualSummary from "../RevenueManagement/ListingComponent/AnnualSummary/AnnualSummary";
import ChoiceBusinessOnTheBook from "../RevenueManagement/ListingComponent/WidgetModule/ChoiceBusinessOnTheBook";
import ChoiceRevenue from "../RevenueManagement/ListingComponent/WidgetModule/ChoiceRevenue";
import DayByDay from "../RevenueManagement/ListingComponent/MarketSegment/DayByDay";
import RoomType from "../RevenueManagement/ListingComponent/MarketSegment/RoomType";
import RatePlanDayByDay from "../RevenueManagement/ListingComponent/RatePlan/DayByDay";
import DynamicPickup from "../RevenueManagement/ListingComponent/PickUp/DynamicPickup";
import LosDayOfWeek from "../RevenueManagement/ListingComponent/ReservationActivity/LosDayOfWeek";
import Top10Chart from "../RevenueManagement/ListingComponent/RatePlan/Top10Chart";
import DayByDayGroup from "../RevenueManagement/ListingComponent/MarketSegment/Group";
import SevenDayBookingReservation from "../RevenueManagement/ListingComponent/PickUp/SevenDayBookingReservation";
import SevenDayBookingExpected from "../RevenueManagement/ListingComponent/PickUp/SevenDayBookingExpected";
import SevenDayBookingPace from "../RevenueManagement/ListingComponent/PickUp/SevenDayBookingPace";
import SevenWeekBookingPace from "../RevenueManagement/ListingComponent/PickUp/SevenWeekBookingPace";
import LengthOfStay from "../RevenueManagement/ListingComponent/MarketSegment/LengthOfStay";
import EmaForecastV2 from "../RevenueManagement/ListingComponent/Forecast/EmaForecastV2";
import EmaForecastV3 from "../RevenueManagement/ListingComponent/Forecast/EmaForecastV3";
import ForecastCommon from "../RevenueManagement/ListingComponent/Forecast/ForecastCommon";
import PickupCommon from "../RevenueManagement/ListingComponent/PickUp/PickupCommon";
import GroupCommon from "../RevenueManagement/ListingComponent/Group/GroupCommon";
import RevYoYChart from "../RevenueManagement/ListingComponent/Chart/RevYoYChart";
import SegmentDrillDown from "../RevenueManagement/ListingComponent/SegmentDrilldown/SegmentDrillDown";
import NinentyDayOutLook from "../RevenueManagement/ListingComponent/RevPak/NinentyDayOutLook";
import LastYearAndForecast from "../RevenueManagement/ListingComponent/LastYearAndForecast/LastYearAndForecast";
import AnnSummary from "../RevenueManagement/ListingComponent/Cancellation/AnnSummary";
import CancellationPace from "../RevenueManagement/ListingComponent/Cancellation/CancellationPace";
import Account from "../RevenueManagement/ListingComponent/Accounts/Account";
import CyCancellationBookingRevLoss from "../RevenueManagement/ListingComponent/Cancellation/CyCancellationBookingRevLoss";
import LyCancellationBookingRevLoss from "../RevenueManagement/ListingComponent/Cancellation/LyCancellationBookingRevLoss";
import StlyCancellationBookingRevLoss from "../RevenueManagement/ListingComponent/Cancellation/StlyCancellationBookingRevLoss";
import Cy2CancellationBookingRevLoss from "../RevenueManagement/ListingComponent/Cancellation/Cy2CancellationBookingRevLoss";
import AnnualCancellationSummary from "../RevenueManagement/ListingComponent/Cancellation/AnnualCancellationSummary";
import MonthlyCancellationPace from "../RevenueManagement/ListingComponent/Cancellation/MonthlyCancellationPace";
import MonthlyCancellationPaceChart from "../RevenueManagement/ListingComponent/Cancellation/MonthlyCancellationPaceChart";
import NinentyDaySegment from "../RevenueManagement/ListingComponent/RevPak/NinentyDaySegment";
import CancellationDayByDay from "../RevenueManagement/ListingComponent/Cancellation/CancellationDayByDay";
import Top50ByRevenue from "../RevenueManagement/ListingComponent/General/Top50ByRevenue";
import YieldRadar from "../RevenueManagement/ListingComponent/General/YieldRadar";
import { setDefaultAsOfDateForHeader } from "../../utils/slices/headerPropertySlice";
import { compName } from "../../utils/constant";
import DailyData from "../RevenueManagement/ListingComponent/Email/DailyData";
import DailyAndMonthlyData from "../RevenueManagement/ListingComponent/Email/DailyAndMonthlyData";

import WeeklyData from "../RevenueManagement/ListingComponent/Email/WeeklyData";
import MonthlyData from "../RevenueManagement/ListingComponent/Email/MonthlyData";
import RunningStar from "../RevenueManagement/ListingComponent/RevPak/RunningStar";
import WeeklyStar from "../RevenueManagement/ListingComponent/RevPak/WeeklyStar";
import { commonService } from "../../utils/commonService";
import StrAnalysis from "../RevenueManagement/ListingComponent/RevPak/StrAnalysis";
import StrDayByDay from "../RevenueManagement/ListingComponent/STR/DayByDay";
import MonthWiseDrillDown from "../RevenueManagement/ListingComponent/SegmentDrilldown/MonthWiseDrillDown";
import PastDynamicPickup from "../RevenueManagement/ListingComponent/PickUp/PastDynamicPickup";
import BookingPaceComparisonChart from "../RevenueManagement/ListingComponent/BookingPace/BookingPaceComparisonChart";
import ThirtyDayPickup from "../RevenueManagement/ListingComponent/PickUp/ThirtyDayPickup";
import BookingPaceComparison from "../RevenueManagement/ListingComponent/BookingPace/BookingPaceComparison";
import PickupAnalysis from "../RevenueManagement/ListingComponent/PickUp/PickupAnalysis";

import PerformanceADRMonitor from "../RevenueManagement/ListingComponent/MoneyControl/PerformanceADRMonitor";
import PricingLadder from "../RevenueManagement/ListingComponent/DynamicPricing/PricingLadder";
import PricingSimulator from "../RevenueManagement/ListingComponent/DynamicPricing/PricingSimulator";

import WordCloudChart from "../RevenueManagement/ListingComponent/General/WordCloudChart";


import ADRRoomSoldOHLC from "../RevenueManagement/ListingComponent/MoneyControl/ADRRoomSoldOHLC";
import ADRRoomSoldMarketSegmentMixAnalysis from "../RevenueManagement/ListingComponent/MoneyControl/ADRRoomSoldMarketSegmentMixAnalysis";
import ProjectedOccupancyTrend from "../RevenueManagement/ListingComponent/MoneyControl/ProjectedOccupancyTrend";

import PropertyOverview from "../RevenueManagement/ListingComponent/Property/PropertyOverview";
import RMCopilot from "../RevenueManagement/ListingComponent/Comments/RMCopilot";
import MarketSegmentDrilldownChart from "../RevenueManagement/ListingComponent/MarketSegment/MarketSegmentDrilldownChart";
import CompsetVariance from "../RevenueManagement/ListingComponent/Property/CompsetVariance";
import LowDemandDates from "../RevenueManagement/ListingComponent/Property/LowDemandDates";
import HighDemandDates from "../RevenueManagement/ListingComponent/Property/HighDemandDates";
import EventStrategy from "../RevenueManagement/ListingComponent/Property/EventStrategy";
import PaceIQ from "../RevenueManagement/ListingComponent/PickUp/PaceIQ";
import BookingPaceNew from "../RevenueManagement/ListingComponent/BookingPace/BookingPaceNew";
import DemandCalender from "../RevenueManagement/ListingComponent/HeatMap/DemandCalender";

import videoblue from "../../Assets/Images/Action Icons/video-blue.png";
import videogreen from "../../Assets/Images/Action Icons/video-green.png";
import {
    errorToastMessage,
    successToastMessage,
} from "../../utils/toastMessage";
import CommonComment from "../RevenueManagement/ListingComponent/Comments/CommonComment";
import ForecastUsingNinetyDayPickup from "../RevenueManagement/ListingComponent/PickUp/ForecastUsingNinetyDayPickup";
import RevenueByCompany from "../RevenueManagement/ListingComponent/CrmSnapshot/RevenueByCompany";
import RevenueByMarketSegment from "../RevenueManagement/ListingComponent/CrmSnapshot/RevenueByMarketSegment";
import RevenueByRoomType from "../RevenueManagement/ListingComponent/CrmSnapshot/RevenueByRoomType";
import ForecastVsOTBChart from "../RevenueManagement/ListingComponent/Forecast/ForecastVsOTBChart";
import PerityCheck from "../RevenueManagement/ListingComponent/RateShop/PerityCheck";
import ChannelMonthlyDrilldown from "../RevenueManagement/ListingComponent/SegmentDrilldown/ChannelMonthlyDrilldown";
import Channel from "../RevenueManagement/ListingComponent/MarketSegment/Channel";
import CrmCancellationActivity from "../RevenueManagement/ListingComponent/CrmSnapshot/CancellationActivity";
import CrmCompanyMonthlyDrilldown from "../RevenueManagement/ListingComponent/CrmSnapshot/CompanyMonthlyDrilldown";
import CrmTodayArrivalDeparture from "../RevenueManagement/ListingComponent/CrmSnapshot/TodayArrivalDeparture";
import BenchMarking from "../RevenueManagement/ListingComponent/RateShop/BenchMarking";
import Rateshop from "../RevenueManagement/ListingComponent/Tools/Rateshop";
import Reminder from "../RevenueManagement/ListingComponent/Tools/Reminder";
import Event from "../RevenueManagement/ListingComponent/Tools/Event";
import RateIq from "../RevenueManagement/ListingComponent/Tools/RateIq";
import DisplacementCalculator from "../RevenueManagement/ListingComponent/Tools/DisplacementCalculator";
import ToolPerityCheck from "../RevenueManagement/ListingComponent/Tools/PerityCheck";
import HeatMapDaywise from "../RevenueManagement/ListingComponent/HeatMap/HeatMapDaywise";
import EventStretegy from "../RevenueManagement/ListingComponent/Event/EventStretegy";
import PastForecastChart from "../RevenueManagement/ListingComponent/Forecast/PastForecastChart";
import WeatherWidget from "../RevenueManagement/ListingComponent/General/WeatherWidget";
import BookingPaceForecastChart from "../RevenueManagement/ListingComponent/BookingPace/BookingPaceForecastChart";
import BookingPaceMonthlyForecast from "../RevenueManagement/ListingComponent/BookingPace/BookingPaceMonthlyForecast";
import DynamicForecastUsingNinetyDayPickup from "../RevenueManagement/ListingComponent/PickUp/DynamicForecastUsingNinetyDayPickup";
import RateShopChart from "../RevenueManagement/ListingComponent/RateShop/RateShopChart";
import SeasonalityAnalysis from "../RevenueManagement/ListingComponent/AnnualSummary/SeasonalityAnalysis";
import ReservationAnalyticsChart from "../RevenueManagement/ListingComponent/MarketSegment/ReservationAnalyticsChart";
import DeleteModal from "../RevenueManagement/DeleteModal";
import MonthlyBookingWindow from "../RevenueManagement/ListingComponent/BookingWindow/MonthlyBookingWindow";
import DayByDayBookingWindow from "../RevenueManagement/ListingComponent/BookingWindow/DayByDayBookingWindow";
import GoogleRatings from "../RevenueManagement/ListingComponent/Analytics/GoogleRatings";
import Reviews from "../RevenueManagement/ListingComponent/Analytics/Reviews";
import Rates from "../RevenueManagement/ListingComponent/Analytics/Rates";
import RatesCount from "../RevenueManagement/ListingComponent/Analytics/RatesCount";
import SentimateReviewCount from "../RevenueManagement/ListingComponent/Analytics/SentimateReviewCount";
import StrategyByReservation from "../RevenueManagement/ListingComponent/ReservationActivity/StrategyByReservation";
import ForecastUsingNinetyDayPickupNew from "../RevenueManagement/ListingComponent/PickUp/ForecastUsingNinetyDayPickupNew";
import BookingCurveNew from "../RevenueManagement/ListingComponent/PickUp/BookingCurveNew";
import RNXAnalysis1 from "../RevenueManagement/ListingComponent/RNX/RNXAnalysis1";
import RNXAnalysis2 from "../RevenueManagement/ListingComponent/RNX/RNXAnalysis2";
import RNXAnalysis3 from "../RevenueManagement/ListingComponent/RNX/RNXAnalysis3";
import RNXisell from "../RevenueManagement/ListingComponent/RNX/RNXisell";
import RNXSOTMPickup from "../RevenueManagement/ListingComponent/RNX/RNXSOTMPickup";
import RNXWOWPickup from "../RevenueManagement/ListingComponent/RNX/RNXWOWPickup";
import CurrentWeekOnTheBooks from "../RevenueManagement/ListingComponent/Report/CurrentWeekOnTheBooks";
import CurrentNextYearOnTheBooks from "../RevenueManagement/ListingComponent/Report/CurrentNextYearOnTheBooks";
import RecapReport from "../RevenueManagement/ListingComponent/Report/RecapReport";

import TransientGroupOnTheBooks from "../RevenueManagement/ListingComponent/Report/TransientGroupOnTheBooks";
import SegmentsWise from "../RevenueManagement/ListingComponent/Report/SegmentsWise";

import RNXAnalysis1_Month from "../RevenueManagement/ListingComponent/RNX/RNXAnalysis1_Month";
import RNXAnalysis1_Day from "../RevenueManagement/ListingComponent/RNX/RNXAnalysis1_Day";
import RNXAnalysis2_RevenuAdrNight from "../RevenueManagement/ListingComponent/RNX/RNXAnalysis2_RevenuAdrNight";
import RNXAnalysis2_RevenueVolumeByChannels from "../RevenueManagement/ListingComponent/RNX/RNXAnalysis2_RevenueVolumeByChannels";
import RNXAnalysis2_BookingPace from "../RevenueManagement/ListingComponent/RNX/RNXAnalysis2_BookingPace";

import RNXAnalysis2_RoomNightVolumeByChannels from "../RevenueManagement/ListingComponent/RNX/RNXAnalysis2_RoomNightVolumeByChannels";
import RNXAnalysis2_RateBand from "../RevenueManagement/ListingComponent/RNX/RNXAnalysis2_RateBand";
import RNXAnalysis2_RoomNightRateBand from "../RevenueManagement/ListingComponent/RNX/RNXAnalysis2_RoomNightRateBand";
import RNXAnalysis2_RatePaceGraph from "../RevenueManagement/ListingComponent/RNX/RNXAnalysis2_RatePaceGraph";
import RNXSOTMPickup_CurrentYear from "../RevenueManagement/ListingComponent/RNX/RNXSOTMPickup_CurrentYear";
import RNXSOTMPickup_STLY from "../RevenueManagement/ListingComponent/RNX/RNXSOTMPickup_STLY";

import Patterns_RevenuePerDayByDow from "../RevenueManagement/ListingComponent/RNX/Patterns_RevenuePerDayByDow";
import Patterns_RoomNightsPerDayByDow from "../RevenueManagement/ListingComponent/RNX/Patterns_RoomNightsPerDayByDow";
import Patterns_ADR from "../RevenueManagement/ListingComponent/RNX/Patterns_ADR";
import Patterns_DOWContributionRevenue from "../RevenueManagement/ListingComponent/RNX/Patterns_DOWContributionRevenue";
import Patterns_DOWContributionRoom from "../RevenueManagement/ListingComponent/RNX/Patterns_DOWContributionRoom";
import Patterns_DOWPatternADR from "../RevenueManagement/ListingComponent/RNX/Patterns_DOWPatternADR";
import Patterns_ArrivalVSStayThisYear from "../RevenueManagement/ListingComponent/RNX/Patterns_ArrivalVSStayThisYear";
import Patterns_ArrivalVSStayLastYear from "../RevenueManagement/ListingComponent/RNX/Patterns_ArrivalVSStayLastYear";
import Patterns_LengthOfStayPatterns from "../RevenueManagement/ListingComponent/RNX/Patterns_LengthOfStayPatterns";

import CMBookingWindowActivity from "../RevenueManagement/ListingComponent/RNX/CMBookingWindowActivity";
import CMBookingWindow from "../RevenueManagement/ListingComponent/RNX/CMBookingWindow";
import CMCancellationHeatmap from "../RevenueManagement/ListingComponent/RNX/CMCancellationHeatmap";

import CMChannel from "../RevenueManagement/ListingComponent/RNX/CMChannel";
import RoomTypeDrillDown from "../RevenueManagement/ListingComponent/SegmentDrilldown/RoomTypeDrillDown";
import GroupIQ from "../RevenueManagement/ListingComponent/GroupIQ/GroupIQ";
import RecommendedRate from "../RevenueManagement/ListingComponent/RecommendedRate/RecommendedRate";
import ChannelMix from "../RevenueManagement/MorningBriefing/ChannelMix";
import EventsAndCompressionRadar from "../RevenueManagement/MorningBriefing/EventsAndCompressionRadar";
import MarketShare from "../RevenueManagement/MorningBriefing/MarketShare";
import PickupAndPace from "../RevenueManagement/MorningBriefing/PickupAndPace";
import RateParity from "../RevenueManagement/MorningBriefing/RateParity";
import RGIByDayofWeek from "../RevenueManagement/MorningBriefing/RGIByDayofWeek";
import ThirtyDayCommandView from "../RevenueManagement/MorningBriefing/ThirtyDayCommandView";
import CancellationExposure from "../RevenueManagement/MorningBriefing/CancellationExposure";
import GroupBlocksOnHighDemandDates from "../RevenueManagement/MorningBriefing/GroupBlocksOnHighDemandDates";
import BookingWindowNext30dArrivals from "../RevenueManagement/MorningBriefing/BookingWindowNext30dArrivals";
import RmBenchMarking from "../RevenueManagement/RmBenchMarking";
import DisplacementCalc from "../RevenueManagement/DisplacementCalc";
import RMPerityCheck from "../RevenueManagement/RMPerityCheck";
import DemandScore from "../RevenueManagement/DemandScore/DemandScore";
import PriceQualityInsights from "../RevenueManagement/PriceQualityInsights";
import WhatIfPricingSimulator from "../RevenueManagement/WhatIfPricingSimulator";
import BudgetSimulator from "../RevenueManagement/BudgetSimulator/BudgetSimulator";
import UserSimulator from "../RevenueManagement/UserSimulator/UserSimulator";
import RMRateShop from "../RevenueManagement/RMRateShop";
import RMRateIq from "../RevenueManagement/RMRateIq";
import AnnualSummaryDrilldown from "../RevenueManagement/ListingComponent/AnnualSummary/AnnualSummaryDrilldown";
import PromoRadar from "../RevenueManagement/ListingComponent/General/PromoRadar";





const TodoDetailModal = ({ todoId, showModal, closeModal, getList }) => {
    const defaultAsOfDateRef = useRef();
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const asOfDateFromRTK = useSelector((store) => store.headerProperty.asOfDate);
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );
    if (defaultAsOfDateFromRTK) {
        defaultAsOfDateRef.current = defaultAsOfDateFromRTK;
    }
    const [todoDetail, setTodoDetail] = useState(null);

    const [IsSchedule, setIsSchedule] = useState(false);
    const [loading, setLoading] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const closeDeleteModal = () => {
        setDeleteModal(false);
        closeModal();
    };

    let componentObj = {
        [compName?.budget]: Budget,
        [compName?.netStly]: NetStly,
        [compName?.onTheBook]: OnTheBook,
        [compName?.totalLy]: TotalLy,
        [compName?.oneDay]: OneDay,
        [compName?.oneDayForecastChange]: OneDayForecastChange,

        [compName?.threeDayForecastChange]: ThreeDayForecastChange,
        [compName?.threeDay]: ThreeDay,

        [compName?.sevenDay]: SevenDay,
        [compName?.sevenDayForecastChange]: SevenDayForecastChange,
        [compName?.group]: Group,
        [compName?.groupLastYear]: GroupLastYear,
        [compName?.transient]: Transient,
        [compName?.transientLastYear]: TransientLastYearGroup,
        [compName?.org]: ORG,
        [compName?.pickupFrom]: PickupFrom,
        [compName?.reservationActivity]: ReservationActivity,
        [compName?.heatMap]: HeatMap,
        [compName?.CancellationHeatMap]: CancellationHeatMap,
        [compName?.widgetBudgetGraph]: WidgetBudgetGraph,
        [compName?.spiderForecast]: Spider,
        [compName?.rmsForecast]: Rms,
        [compName?.userForecast]: User,
        [compName?.choiceRes]: ChoiceRes,
        [compName?.mstReservation]: MstReservation,
        [compName?.dailyDataTransaction]: DailyDataTransaction,
        [compName?.emaForecast]: EMAForecast,
        [compName?.annualSummaryChart]: AnnualSummaryChart,
        [compName?.forecastChart]: ForecastChart,
        [compName?.pickupChart]: PickupChart,
        [compName?.groupChart]: GroupChart,
        [compName?.GroupWash]: GroupWash,
        [compName?.RecommendedRate]: RecommendedRate,
        [compName?.bookingPaceChart]: BookinPaceChart,
        [compName?.marketSegmentChart]: MarketSegmentChart,
        [compName?.DayOfWeekSegmentMix]: DayOfWeekSegmentMix,
        [compName?.widgetChoiceOccupancy]: ChoiceOccupancy,
        [compName?.widgetHotelKeyReservation]: HotelKeyReservation,
        [compName?.widgetHotelKeyOccupancySnapshot]: HotelKeyOccupancySnapshot,
        [compName?.widgetBestWesternGuestName]: BestWesternGuestName,
        [compName?.widgetBestWesternReservationAgent]: BestWesternReservationAgent,
        [compName?.widgetBestWesternReservationForecast]:
            BestWesternReservationForecast,
        [compName?.widgetBestWesternRoomMaintaince]: BestWesternRoomMaintaince,
        [compName?.widgetChoiceCancelationSummary]: ChoiceCancelationSummaryReport,
        [compName?.adrVsRateChart]: AdrVsRateChart,
        [compName?.widgetPickup]: WidgetPickup,
        [compName?.bookingPaceTable]: BookingPaceTable,
        [compName?.annualSummary]: AnnualSummary,
        [compName?.widgetChoiceBusinessOTB]: ChoiceBusinessOnTheBook,
        [compName?.widgetChoiceRevenue]: ChoiceRevenue,
        [compName?.marketSegmentDayByDay]: DayByDay,
        [compName?.marketSegmentRoomType]: RoomType,
        [compName?.ratePlanDayByDay]: RatePlanDayByDay,
        [compName?.dynamicPickup]: DynamicPickup,
        [compName?.losDayOfWeek]: LosDayOfWeek,
        [compName?.top10Chart]: Top10Chart,
        [compName?.dayByDayGroup]: DayByDayGroup,
        [compName?.sevenDayBookingReservation]: SevenDayBookingReservation,
        [compName?.sevenDayBookingExpected]: SevenDayBookingExpected,
        [compName?.sevenDayBookingPace]: SevenDayBookingPace,
        [compName?.sevenWeekBookingPace]: SevenWeekBookingPace,
        [compName?.lengthOfStay]: LengthOfStay,
        [compName?.emaForecastV2]: EmaForecastV2,
        [compName?.emaForecastV3]: EmaForecastV3,
        [compName?.forecastCommon]: ForecastCommon,
        [compName?.pickupCommon]: PickupCommon,
        [compName?.groupCommon]: GroupCommon,
        [compName?.revYoYChart]: RevYoYChart,
        [compName?.segmentDrillDown]: SegmentDrillDown,
        [compName?.roomTypeDrillDown]: RoomTypeDrillDown,
        [compName?.ninetyDayOutlook]: NinentyDayOutLook,
        [compName?.lastYearAndForecast]: LastYearAndForecast,
        [compName?.annSummaryCancellation]: AnnSummary,
        [compName?.cancellationPace]: CancellationPace,
        [compName?.account]: Account,
        [compName?.cyCancellationBookingRevLoss]: CyCancellationBookingRevLoss,
        [compName?.lyCancellationBookingRevLoss]: LyCancellationBookingRevLoss,
        [compName?.stlyCancellationBookingRevLoss]: StlyCancellationBookingRevLoss,
        [compName?.cy2CancellationBookingRevLoss]: Cy2CancellationBookingRevLoss,
        [compName?.annCancellationSummary]: AnnualCancellationSummary,
        [compName?.monthlyCancellationPace]: MonthlyCancellationPace,
        [compName?.monthlyCancellationPaceChart]: MonthlyCancellationPaceChart,
        [compName?.ninetyDaySegment]: NinentyDaySegment,
        [compName?.cancellationDayByDay]: CancellationDayByDay,
        [compName?.top50ByRevenue]: Top50ByRevenue,
        [compName?.YieldRadar]: YieldRadar,

        
        [compName?.dailyDataForEmail]: DailyData,
        [compName?.DailyAndMonthlyData]: DailyAndMonthlyData,

        [compName?.weeklyDataForEmail]: WeeklyData,
        [compName?.monthlyDataForEmail]: MonthlyData,
        [compName?.runningStrReport]: RunningStar,
        [compName?.weeklyStrReport]: WeeklyStar,
        [compName?.strAnalysis]: StrAnalysis,
        [compName?.strDayByDay]: StrDayByDay,
        [compName?.monthlySegmentDrilldown]: MonthWiseDrillDown,
        [compName?.pastDynamicPickup]: PastDynamicPickup,
        [compName?.bookingPaceComparisonChart]: BookingPaceComparisonChart,
        [compName?.thirtyDayPickup]: ThirtyDayPickup,
        [compName?.bookingPaceComparison]: BookingPaceComparison,
        [compName?.commentWidget]: CommonComment,
        [compName?.forecastUsing90DayPickup]: ForecastUsingNinetyDayPickup,
        [compName?.crmRevnueByCompany]: RevenueByCompany,
        [compName?.crmRevenueByRoomType]: RevenueByRoomType,
        [compName?.crmRevenueByMarketSegment]: RevenueByMarketSegment,
        [compName?.forecastvsOtbChart]: ForecastVsOTBChart,
        [compName?.perityCheck]: PerityCheck,
        [compName?.channelMonthlyDrilldown]: ChannelMonthlyDrilldown,
        [compName?.dayByDayChannel]: Channel,
        [compName?.crmCancellationActivity]: CrmCancellationActivity,
        [compName?.crmCompanyDrilldown]: CrmCompanyMonthlyDrilldown,
        [compName?.crmArrialDeparture]: CrmTodayArrivalDeparture,
        [compName?.rateShopBenchmarking]: BenchMarking,
        [compName?.toolRateShop]: Rateshop,
        [compName?.toolReminder]: Reminder,
        [compName?.toolEvent]: Event,
        [compName?.toolRateIq]: RateIq,
        [compName?.toolDisplacementCalculator]: DisplacementCalculator,
        [compName?.toolPerityCheck]: ToolPerityCheck,
        [compName?.heatMapdaywise]: HeatMapDaywise,
        [compName?.eventStretegyWidget]: EventStretegy,
        [compName?.pastForecastChart]: PastForecastChart,
        [compName?.weatherWidget]: WeatherWidget,
        [compName?.bookingPaceForecastComparison]: BookingPaceForecastChart,
        [compName?.bookingPaceMonthlyForecast]: BookingPaceMonthlyForecast,
        [compName?.dynamicForecastUsingNinentyDayPickup]:
            DynamicForecastUsingNinetyDayPickup,
        [compName?.rateShopChart]: RateShopChart,
        [compName?.seasonalityAnalysis]: SeasonalityAnalysis,
        [compName?.marketSegmentWiseReservation]: ReservationAnalyticsChart,
        [compName?.monthlyBookingWindow]: MonthlyBookingWindow,
        [compName?.dayByDayBookingWindow]: DayByDayBookingWindow,
        [compName?.googleRatings]: GoogleRatings,
        [compName?.analyticsReview]: Reviews,
        [compName?.analyticsRates]: Rates,
        [compName?.analyticsRatesCount]: RatesCount,
        [compName?.analyticsSentimateReview]: SentimateReviewCount,
        [compName?.strategyByReservation]: StrategyByReservation,
        [compName?.forecastUsingNinetyDayPickupNew]:
            ForecastUsingNinetyDayPickupNew,
        [compName?.bookingCurveNew]: BookingCurveNew,
        [compName?.PickupAnalysis]: PickupAnalysis,

        [compName?.PerformanceADRMonitor]: PerformanceADRMonitor,
        [compName?.PricingLadder]: PricingLadder,
        [compName?.WordCloudChart]: WordCloudChart,

        [compName?.PricingSimulator]: PricingSimulator,


        [compName?.ADRRoomSoldOHLC]: ADRRoomSoldOHLC,
        [compName?.ADRRoomSoldMarketSegmentMixAnalysis]:
            ADRRoomSoldMarketSegmentMixAnalysis,
        [compName?.ProjectedOccupancyTrend]: ProjectedOccupancyTrend,

        [compName?.PropertyOverview]: PropertyOverview,
        [compName?.RMCopilot]: RMCopilot,
        [compName?.MarketSegmentDrilldownChart]: MarketSegmentDrilldownChart,
        [compName?.RNXAnalysis1]: RNXAnalysis1,
        [compName?.RNXAnalysis2]: RNXAnalysis2,
        [compName?.RNXAnalysis3]: RNXAnalysis3,
        [compName?.RNXisell]: RNXisell,
        [compName?.RNXSOTMPickup]: RNXSOTMPickup,
        [compName?.RNXWOWPickup]: RNXWOWPickup,
        [compName?.CurrentWeekOnTheBooks]: CurrentWeekOnTheBooks,
        [compName?.CurrentNextYearOnTheBooks]: CurrentNextYearOnTheBooks,
        [compName?.RecapReport]: RecapReport,

        [compName?.TransientGroupOnTheBooks]: TransientGroupOnTheBooks,
        [compName?.SegmentsWise]: SegmentsWise,

        [compName?.CompsetVariance]: CompsetVariance,
        [compName?.LowDemandDates]: LowDemandDates,
        [compName?.HighDemandDates]: HighDemandDates,
        [compName?.EventStrategy]: EventStrategy,
        [compName?.PaceIQ]: PaceIQ,
        [compName?.BookingPaceNew]: BookingPaceNew,
        [compName?.DemandCalender]: DemandCalender,

        [compName?.RNXAnalysis1_Month]: RNXAnalysis1_Month,
        [compName?.RNXAnalysis1_Day]: RNXAnalysis1_Day,
        [compName?.RNXAnalysis2_RevenuAdrNight]: RNXAnalysis2_RevenuAdrNight,
        [compName?.RNXAnalysis2_RevenueVolumeByChannels]:
            RNXAnalysis2_RevenueVolumeByChannels,
        [compName?.RNXAnalysis2_BookingPace]: RNXAnalysis2_BookingPace,

        [compName?.RNXAnalysis2_RoomNightVolumeByChannels]:
            RNXAnalysis2_RoomNightVolumeByChannels,
        [compName?.RNXAnalysis2_RateBand]: RNXAnalysis2_RateBand,
        [compName?.RNXAnalysis2_RoomNightRateBand]: RNXAnalysis2_RoomNightRateBand,
        [compName?.RNXAnalysis2_RatePaceGraph]: RNXAnalysis2_RatePaceGraph,
        [compName?.RNXSOTMPickup_CurrentYear]: RNXSOTMPickup_CurrentYear,
        [compName?.RNXSOTMPickup_STLY]: RNXSOTMPickup_STLY,

        [compName?.Patterns_RevenuePerDayByDow]: Patterns_RevenuePerDayByDow,
        [compName?.Patterns_RoomNightsPerDayByDow]: Patterns_RoomNightsPerDayByDow,
        [compName?.Patterns_ADR]: Patterns_ADR,
        [compName?.Patterns_DOWContributionRevenue]:
            Patterns_DOWContributionRevenue,
        [compName?.Patterns_DOWContributionRoom]: Patterns_DOWContributionRoom,
        [compName?.Patterns_DOWPatternADR]: Patterns_DOWPatternADR,
        [compName?.Patterns_ArrivalVSStayThisYear]: Patterns_ArrivalVSStayThisYear,
        [compName?.Patterns_ArrivalVSStayLastYear]: Patterns_ArrivalVSStayLastYear,
        [compName?.Patterns_LengthOfStayPatterns]: Patterns_LengthOfStayPatterns,

        [compName?.CMBookingWindowActivity]: CMBookingWindowActivity,
        [compName?.CMBookingWindow]: CMBookingWindow,
        [compName?.CMCancellationHeatmap]: CMCancellationHeatmap,

        [compName?.CMChannel]: CMChannel,
        [compName?.GroupIQ]: GroupIQ,

        [compName?.ChannelMix]: ChannelMix,
        [compName?.EventsAndCompressionRadar]: EventsAndCompressionRadar,
        [compName?.MarketShare]: MarketShare,
        [compName?.PickupAndPace]: PickupAndPace,
        [compName?.RateParity]: RateParity,
        [compName?.RGIByDayofWeek]: RGIByDayofWeek,
        [compName?.ThirtyDayCommandView]: ThirtyDayCommandView,
        [compName?.CancellationExposure]: CancellationExposure,
        [compName?.GroupBlocksOnHighDemandDates]: GroupBlocksOnHighDemandDates,
        [compName?.BookingWindowNext30dArrivals]: BookingWindowNext30dArrivals,

        // Tools Component convert into Widgets
        [compName?.RmBenchMarking]: RmBenchMarking,
        [compName?.DisplacementCalc]: DisplacementCalc,
        [compName?.RMPerityCheck]: RMPerityCheck,
        [compName?.DemandScore]: DemandScore,
        [compName?.PriceQualityInsights]: PriceQualityInsights,
        [compName?.WhatIfPricingSimulator]: WhatIfPricingSimulator,
        [compName?.BudgetSimulator]: BudgetSimulator,
        [compName?.UserSimulator]: UserSimulator,
        [compName?.RMRateShop]: RMRateShop,
        [compName?.RMRateIq]: RMRateIq,
       
        [compName?.AnnualSummaryDrilldown]: AnnualSummaryDrilldown,
        [compName?.PromoRadar]: PromoRadar,

    };

    const getTodoByPrimaryKey = async () => {
        setIsSchedule(false);
        let todoResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration + API_URL.TODO.GET_BY_PRIMARY_KEY,
                body: {
                    id: todoId,
                },
            },
            false
        );

        let response = apiResponse(false, todoResponse);

        if (response?.isValidate) {
            setTodoDetail(response?.data?.data);
            if (
                response?.data?.data.associationtype !== null &&
                response?.data?.data.associationtype.toUpperCase() === "SCHEDULE"
            ) {
                setIsSchedule(true);
            }
        }

        if (!response?.isValidate) {
            setTodoDetail(null);
        }
    };

    const fnJoinZoomMeeting = async (obj) => {
        if (new Date() >= new Date(obj.tododate)) {
            let propertyResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.RevenueManagement +
                        API_URL.SCHEDULE_REVENUE.GET_DETAIL_BYID,
                    body: {
                        id: obj.associationid,
                    },
                },
                false
            );

            let response = apiResponse(false, propertyResponse);

            if (response?.isValidate) {
                var meetingdetails = response?.data?.data?.schedule[0].meetingdetails;
                if (
                    meetingdetails !== null &&
                    meetingdetails !== undefined &&
                    meetingdetails !== ""
                ) {
                    var MeetObj = JSON.parse(meetingdetails);
                    if (
                        MeetObj.join_url !== null &&
                        MeetObj.join_url !== undefined &&
                        MeetObj.join_url !== ""
                    ) {
                        window.open(MeetObj.join_url, "_blank");
                    }
                }
            }
        } else {
            errorToastMessage(
                "Meeting date and time is " +
                commonService.getDateTimeInFormat(obj.tododate)
            );
        }
    };

    useEffect(() => {
        getTodoByPrimaryKey();
    }, []);
    return (
        <>
            <Modal
                className="AddPropertySetupModalMain todo-detail-modal-main-wrapper"
                size="lg"
                centered
                show={showModal}
                onHide={closeModal}
            >
                <Modal.Header>
                    <Modal.Title
                        id="contained-modal-title-vcenter"
                        title={todoDetail?.title}
                    >
                        {todoDetail?.title?.length > 80
                            ? todoDetail?.title.slice(0, 80) + "..."
                            : todoDetail?.title}
                    </Modal.Title>
                    <div className="d-flex align-items-center gap-3">
                        {IsSchedule && new Date() >= new Date(todoDetail.tododate) ? (
                            <img id={commonService.generateGlobalClickTrackerID("TodoDetailModal", "viewicon", "")}
                                src={videogreen}
                                alt="viewIcon"
                                onClick={(e) => fnJoinZoomMeeting(todoDetail)}
                            />
                        ) : (
                            <img id={commonService.generateGlobalClickTrackerID("TodoDetailModal", "viewicon", "")}
                                src={videoblue}
                                alt="viewIcon"
                                onClick={(e) => fnJoinZoomMeeting(todoDetail)}
                            />
                        )}
                        {todoDetail?.status === "Not Done" ? (
                            <Badge className="default-badge inactive-badge">Not Done</Badge>
                        ) : (
                            <Badge className="default-badge active-badge">Done</Badge>
                        )}
                        <button id={commonService.generateGlobalClickTrackerID("TodoDetailModal", "button-onclick", "")}
                            type="button"
                            class="btn-close"
                            aria-label="Close"
                            onClick={closeModal}
                        ></button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <Row>
                            <Col xl={12}>
                                <p className="todoDetail">
                                    {todoDetail?.associationtype === "WIDGETNOTE" ? (
                                        <div
                                            dangerouslySetInnerHTML={{ __html: todoDetail?.details }}
                                        ></div>
                                    ) : (
                                        <div>{todoDetail?.details}</div>
                                    )}
                                </p>
                            </Col>

                            {/* {todoDetail?.associationtype === "WIDGETNOTE" &&
                React.createElement(componentObj[todoDetail?.componentname], {
                  api: 1,
                  para: {
                    propertyDetail: propertyDetailFromRTK,
                    propertyCode: todoDetail?.propertycode,
                    // asOfDate: asOfDateFromRTK,
                    asOfDate: commonService.getDateForNode(
                      todoDetail?.asofdate
                    ),
                    widgetId: todoDetail?.widgetid,
                    defaultAsOfDate: defaultAsOfDateRef.current,
                    rowTitle: "",
                  },
                  setting: "",
                })} */}
                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button id={commonService.generateGlobalClickTrackerID("TodoDetailModal", "delete", "")}
                        className="default-btn primary-btn red-btn"
                        onClick={() => {
                            setDeleteModal(true);
                        }}
                    >
                        Delete
                    </button>
                </Modal.Footer>
            </Modal>
            {deleteModal && (
                <DeleteModal
                    showDeleteItemModal={deleteModal}
                    closeDeleteItemModal={closeDeleteModal}
                    payload={{
                        id: parseInt(todoId),
                        date: commonService.getDateInDBFormat(new Date()),
                        type: "Todo",
                    }}
                    getList={getList}
                    url={
                        API_URL.BASE_API_URL.RevenueManagement +
                        API_URL.EVENTS.DELETE_REVENUE_DASHBOARD_EVENT
                    }
                />
            )}
        </>
    );
};

export default TodoDetailModal;
